import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import Address from "@/shared/model/Address";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";


interface Props {
  address?:Address

}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'AddressCardComponent',
  props: {
    address: { default: undefined }
  },
  setup(__props: any) {

const props = __props
/*const _classCard = computed(()=>{
  let res = "sog-card"
  if(props.isSelected){
    res += " selected"
  }
  if(props.allowSelect){
    res += " allow-select"
  }
  return res

})*/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogFlexColumn, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.fullName
                }, null, 8, ["value"])
              ], 512), [
                [_vShow, props.address?.fullName]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.line1
                }, null, 8, ["value"])
              ], 512), [
                [_vShow, props.address?.line1 && props.address?.line1!=='']
              ]),
              _createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.street
                }, null, 8, ["value"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createVNode(SogDataLabel, {
                  value: props.address?.houseNumber
                }, null, 8, ["value"]),
                _createVNode(SogDataLabel, {
                  value: props.address?.houseNumberAddition
                }, null, 8, ["value"])
              ]),
              _createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.postalCode
                }, null, 8, ["value"]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(SogDataLabel, {
                  value: props.address?.city
                }, null, 8, ["value"])
              ]),
              _createVNode(SogDataLabel, {
                value: props.address?.countryName
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})